var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [_c("div", { staticClass: "form_title" }, [_vm._v("奖项设置")])]
      ),
      _c("roleTable", { ref: "roleTable" }),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c("a-button", { on: { click: _vm.lastStep } }, [_vm._v("上一步")]),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v("下一步")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }